export function isSafari() {
  return (
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  );
}

export function isFirefox() {
  return (
    /Firefox/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  );
}

export function isInternetExplorer() {
  return (
    /Mozilla/.test(navigator.userAgent) &&
    !/Firefox/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent) &&
    !/Safari/.test(navigator.userAgent) &&
    !/Opera/.test(navigator.userAgent)
  );
}

const WEBVIEW_SESSION_KEY = '__imgoing_in_app_webview__';


function hasExplicitWebViewFlag(): boolean {
  if ((window as any).__IMGOING_WEBVIEW__ === true) return true;
  try {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('webview') ?? params.get('inApp') ?? params.get('isApp');
    return value != null && /^(1|true|yes)$/i.test(value);
  } catch {
    return false;
  }
}

function hasNativeAppBridge(): boolean {
  const w = window as any;
  return !!(
    w.flutter_inappwebview ||
    w.FlutterChannel ||
    w.LoginChannel ||
    w.OAuthChannel ||
    w.AppChannel ||
    w.ReactNativeWebView
  );
}

function isNativeWebViewUserAgent(): boolean {
  const ua = navigator.userAgent || '';


  const isAndroid = /Android/i.test(ua);
  const isAndroidWebView =
    isAndroid && (/\bwv\b/i.test(ua) || (/Version\/\d+/i.test(ua) && !/Chrome\/\d+/i.test(ua)));

  const isIOS = /iP(ad|hone|od)/i.test(ua);
  const isIOSWebView = isIOS && /AppleWebKit/i.test(ua) && !/Safari\//i.test(ua);

  return isAndroidWebView || isIOSWebView;
}

export function isInAppWebView(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

  try {
    if (sessionStorage.getItem(WEBVIEW_SESSION_KEY) === '1') return true;
  } catch {
  }

  const detected =
    hasExplicitWebViewFlag() || hasNativeAppBridge() || isNativeWebViewUserAgent();

  if (detected) {
    try {
      sessionStorage.setItem(WEBVIEW_SESSION_KEY, '1');
    } catch {
    }
  }

  return detected;
}
